<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>
          Review Changes In {{ isContractor(user) ? 'PayOut' : 'Salary' }} ({{
            employeeSalary?.ctc?.basis ?? '' | capitalize
          }})
        </h3>
        <h4>4/4</h4>
      </div>
      <!--Compliance Summary-->
      <!--<div class="d-flex justify-content-between pt-3">
        <p>
          Applicable Compliances:
          <ng-container *ngIf="hasValidCompliances(); else noCompliance">
            <ng-container *ngFor="let compliance of compliancesList | keyvalue">
              <span
                class="badge bg-soft-info me-1"
                *ngIf="compliance.key !== 'employerCapping' && compliance.value === true"
              >
                {{ compliance.key + '' | uppercase }}
              </span>
            </ng-container>
          </ng-container>

          <ng-template #noCompliance>
            <span>None</span>
          </ng-template>
        </p>
        <button
          class="btn btn-link text-primary text-decoration-underline p-0 border-0"
          (click)="goToScreen()"
        >
          Edit
        </button>
      </div>-->
      <!--/Compliance Summary-->

      <!--Salary Summary-->
      <ng-container *ngIf="salaryComparison.length > 0; else noChanges">
        <table class="table datatable">
          <thead class="thead-light">
            <tr>
              <th></th>
              <th>Previous {{ isContractor(user) ? 'PayOut' : 'Salary' }}</th>
              <th>New {{ isContractor(user) ? 'PayOut' : 'Salary' }}</th>
              <th>Difference</th>
            </tr>
          </thead>
          <tbody>
            <!--<tr>
            <td>Effective From</td>
            <td>{{ employeeSalary?.ctc?.effectiveFrom | date: 'MMM-dd-yyyy' }}</td>
            <td>{{ revisedSalary?.ctc?.effectiveFrom | date: 'MMM-dd-yyyy' }}</td>
            <td></td>
          </tr>-->
            <tr *ngFor="let item of salaryComparison">
              <td>{{ item.itemName }}</td>

              <!-- Previous Value -->
              <td>
                <ng-container *ngIf="item.isComplianceList; else nonCompliancePrev">
                  {{ item.previousValue }}
                  <!-- Display compliance list as string -->
                </ng-container>
                <ng-template #nonCompliancePrev>
                  <ng-container *ngIf="item.isNumeric; else nonNumericPrev">
                    {{ item.previousValue }}
                    <!-- Format numbers -->
                  </ng-container>
                  <ng-template #nonNumericPrev>
                    <ng-container
                      *ngIf="
                        item.category === 'CTC' &&
                          (item.itemName === 'Effective From' || item.itemName === 'Payout From') &&
                          item.previousValue !== 'N/A';
                        else justTextPrev
                      "
                    >
                      {{ item.previousValue | date: 'MMM-dd-yyyy' }}
                    </ng-container>
                    <ng-template #justTextPrev>
                      {{ item.previousValue }}
                    </ng-template>
                  </ng-template>
                </ng-template>
              </td>

              <!-- Revised Value -->
              <td>
                <ng-container *ngIf="item.isComplianceList; else nonComplianceRev">
                  {{ item.revisedValue }}
                  <!-- Display compliance list as string -->
                </ng-container>
                <ng-template #nonComplianceRev>
                  <ng-container *ngIf="item.isNumeric; else nonNumericRev">
                    <ng-container *ngIf="typeof item.revisedValue === 'number'; else revText">
                      {{ item.revisedValue }}
                    </ng-container>
                    <ng-template #revText>{{ item.revisedValue }}</ng-template>
                  </ng-container>
                  <ng-template #nonNumericRev>
                    <!-- Check if it's a date item and apply date pipe -->
                    <ng-container
                      *ngIf="
                        item.category === 'CTC' &&
                          (item.itemName === 'Effective From' || item.itemName === 'Payout From') &&
                          item.revisedValue !== 'N/A';
                        else justTextRev
                      "
                    >
                      {{ item.revisedValue | date: 'MMM-dd-yyyy' }}
                    </ng-container>
                    <ng-template #justTextRev>
                      {{ item.revisedValue }}
                    </ng-template>
                  </ng-template>
                </ng-template>
              </td>
              <!-- Difference / Change Direction -->
              <td>
                <ng-container
                  *ngIf="
                    item.isNumeric &&
                      item.difference !== undefined &&
                      typeof item.difference === 'number';
                    else nonNumericDifference
                  "
                >
                  <span
                    [ngClass]="{
                      'positive-change': item.isChanged && item.difference > 0,
                      'negative-change': item.isChanged && item.difference < 0
                    }"
                  >
                    {{ item.difference > 0 ? '+' : '' }}{{ item.difference | number: '1.2-2' }} ({{
                      item.percentageChange
                    }}%)
                  </span>
                </ng-container>
                <ng-template #nonNumericDifference>
                  <ng-container *ngIf="item.isComplianceList && item.isChanged">
                    <!-- Display Added Compliances -->
                    <div
                      *ngIf="item.addedCompliances && item.addedCompliances.length > 0"
                      class="compliance-changes"
                    >
                      <span
                        *ngFor="let added of item.addedCompliances"
                        class="badge bg-outline-success"
                        >{{ added }}</span
                      >
                    </div>
                    <!-- Display Removed Compliances -->
                    <div
                      *ngIf="item.removedCompliances && item.removedCompliances.length > 0"
                      class="compliance-changes"
                    >
                      <span
                        *ngFor="let removed of item.removedCompliances"
                        class="badge bg-outline-danger"
                        >{{ removed }}</span
                      >
                    </div>
                  </ng-container>
                  <!-- Added/Removed Text for other items -->
                  <ng-container *ngIf="item.isChanged && item.revisedValue === 'Removed'">
                    <span class="badge bg-danger-subtle text-danger-emphasis">Removed</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      item.isChanged &&
                      item.previousValue === 'N/A' &&
                      item.revisedValue !== 'Removed'
                    "
                  >
                    <span class="badge bg-success-subtle text-success-emphasis">Added</span>
                  </ng-container>

                  <!-- No difference shown for date changes, the change is implicit in Prev/New columns -->
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #noChanges>
        <div class="alert alert-info mt-3" role="alert">
          No changes detected between the previous and current
          {{ isContractor(user) ? 'PayOut' : 'Salary' }} structures.
        </div>
      </ng-template>
    </div>
  </div>
</div>
